var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.headerConfig.page_title,
      "page-image": _vm.headerConfig.page_image,
      "page-kv-image": _vm.headerConfig.page_kv_image,
      "header-section": _vm.headerConfig.header_section
    }
  }), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "sales-tool"
  }, [_c('h1', {
    staticClass: "sales-tool__title mt-3 mb-4"
  }, [_vm._v(_vm._s(_vm.deepGet(_vm.moduleConfig, 'text.page_title', '')))]), _vm.currentStep === 1 ? _c('div', {
    staticClass: "sales-tool__step"
  }, [_c('ShareButton', {
    staticClass: "sales-tool__button",
    attrs: {
      "variant": "s-btn-outline-primary"
    },
    on: {
      "click": _vm.handleCameraIsClicked
    }
  }, [_vm._v(" 開啟相機 ")])], 1) : _vm._e(), _vm.currentStep === 2 ? _c('div', {
    staticClass: "sales-tool__step"
  }, [_c('div', {
    staticClass: "sales-tool__scanner"
  }, [_c('QRCodeScanner', {
    ref: "qrScanner",
    attrs: {
      "qrbox": _vm.qrbox
    },
    on: {
      "onScan": _vm.handleQrCodeIsScanned
    }
  })], 1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.scannedUrl,
      expression: "scannedUrl"
    }],
    staticClass: "sales-tool__input",
    attrs: {
      "placeholder": _vm.deepGet(_vm.moduleConfig, 'text.url_input_placeholder', '')
    },
    domProps: {
      "value": _vm.scannedUrl
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.scannedUrl = $event.target.value;
      }
    }
  }), _c('ShareButton', {
    staticClass: "sales-tool__button mt-4",
    attrs: {
      "variant": "s-btn-outline-primary"
    },
    on: {
      "click": _vm.handleNextStepIsClicked
    }
  }, [_vm._v(" 下一步 ")])], 1) : _vm._e(), _vm.currentStep === 3 ? _c('div', {
    staticClass: "sales-tool__step"
  }, [_c('div', {
    staticClass: "sales-tool__form"
  }, [_c('div', {
    staticClass: "sales-tool__radio-group"
  }, _vm._l(_vm.radioOptions, function (option) {
    return _c('label', {
      key: option.type,
      staticClass: "sales-tool__radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.orderType,
        expression: "orderType"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": option.type,
        "checked": _vm._q(_vm.orderType, option.type)
      },
      on: {
        "change": [function ($event) {
          _vm.orderType = option.type;
        }, function ($event) {
          return _vm.handleOrderTypeChanged(option);
        }]
      }
    }), _c('span', {
      staticClass: "sales-tool__radio-label"
    }, [_vm._v(_vm._s(option.text))])]);
  }), 0), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.notes,
      expression: "notes"
    }],
    staticClass: "sales-tool__textarea mt-3",
    attrs: {
      "placeholder": "請輸入備註...",
      "rows": "6"
    },
    domProps: {
      "value": _vm.notes
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value;
      }
    }
  }), _c('ShareButton', {
    staticClass: "sales-tool__button mt-2 w-100",
    attrs: {
      "variant": "s-btn-outline-primary"
    },
    on: {
      "click": _vm.handleConfirmIsClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.moduleConfig, 'text.confirm_button', '')) + " ")]), _c('div', {
    staticClass: "sales-tool__button-group mt-4"
  }, [_c('ShareButton', {
    staticClass: "sales-tool__button mt-2 w-100",
    attrs: {
      "disabled": !_vm.sharingButtonsAreEnabled
    },
    on: {
      "click": _vm.handleCopyIsClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.moduleConfig, 'text.copy_button', '')) + " ")]), _c('ShareButton', {
    staticClass: "sales-tool__button mt-2 w-100",
    attrs: {
      "disabled": !_vm.sharingButtonsAreEnabled
    },
    on: {
      "click": _vm.handleLineShareIsClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.moduleConfig, 'text.line_button', '')) + " ")])], 1), _c('button', {
    staticClass: "sales-tool__button sales-tool__button--text mt-4",
    on: {
      "click": _vm.handleReturnIsClicked
    }
  }, [_vm._v("返回掃描")])], 1)]) : _vm._e()])]), _vm.isCheckingExistence ? _c('Loading', {
    attrs: {
      "loading-message": "檢查兌換碼中...",
      "backgroundColor": "rgba(255, 255, 255, 0.8)"
    }
  }) : _vm._e(), _vm.isSavingRedeemCode ? _c('Loading', {
    attrs: {
      "loading-message": "儲存中...",
      "backgroundColor": "rgba(255, 255, 255, 0.8)"
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }